import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API_URL_DIC_LISTS } from 'manager/http-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../../platform.component';

@Component({
  selector: 'app-diff-table',
  templateUrl: './diff-table.component.html',
  styleUrls: ['./diff-table.component.scss', '../../platform.component.scss'],
})

/**
 * 共通部品_比較画面ダイアログ
 */
export class DiffTableComponent extends PlatformComponent {
  // 呼び出し元の画面ID格納先
  screen_id: string;

  // REST APIエンドポイント格納先
  endPoint: string;

  // 対象データのID格納先
  pkeyId: string;

  // 内閣府承認ダイアログ表示フラグ(true:ダイアログ状態、false:ダイアログ非状態)
  diffTableDialogFlag: boolean = false;

  // 辞書情報格納先
  approvalSpecCodeList: any;

  /* 画面用プロパティ */
  // 画面ヘッダー情報格納先
  columnOrder: any[] = new Array();

  // 画面検索結果格納先
  searchResultLogList: any[] = new Array();

  // 画面検索結果格納先
  searchResultList: any[] = new Array();

  // 提案/依頼画面c601判定用
  suggestOrRequest: string;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {}

  /**
   * 内閣府承認ダイアログ表示
   * @param endPoint REST APIエンドポイント
   * @param pkeyId 対象データのID
   * @param dicId ラジオボタン辞書値
   * @param hideCode 非表示ラジオボタン
   */
  public openDiffTable(
    screen_id: string,
    endPoint: string,
    endPointLog : string,
    pkeyId: string,
    dicId: number,
    ...hideCode: number[]
  ): void {
    // 内閣府承認ダイアログが既に表示済みの場合
    if (this.diffTableDialogFlag) {
      // 処理を終了
      return;
    }

    // 辞書値リストを取得を実施
    this.getApprovalSpecCodeList(dicId,hideCode);

    // 更新前データを取得
    if(endPointLog){
      this.getSearchResultLogList(endPointLog, pkeyId, screen_id);
    }

    // 更新後データを取得
    this.getSearchResultList(endPoint, pkeyId, screen_id);

    // 呼び出し元の画面IDを格納
    this.screen_id = screen_id;

    // REST APIエンドポイントを格納
    this.endPoint = endPoint;

    // 対象データのIDを格納
    this.pkeyId = pkeyId;

    // 内閣府承認ダイアログ表示
    this.diffTableDialogFlag = true;

    // 提案/依頼をセッションから取得(suggest:提案, request:依頼)
    if("c601" == screen_id){
      this.suggestOrRequest = sessionStorage.getItem('suggestOrRequest');
    }
  }

  /**
   * 項目一覧取得
   */
  public getColumnHeader(template_id: number): void {
    // 項目一覧を取得
    this.dbOperationService
      .getHeaderList(template_id)
      .subscribe((response) => {
        // 検索結果を格納
        this.columnOrder = response.body;
      });
  }

  /**
   * 更新前検索結果取得
   */
  public getSearchResultLogList(endPoint: string, pkeyId: string, screen_id: string): void {
    if(screen_id == "b211" || screen_id == "b212" || screen_id == "e202"){
      // 検索結果を取得
      this.dbOperationService
        .getNoTemplateDisplayData(endPoint, pkeyId, true)
        .subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            // // 前画面へ戻る
            // this.location.back();
          } else {
            // 検索結果を格納
            this.searchResultLogList = response.body;
          }
        });
    }else if( screen_id == "h301" ) {
      // 検索結果を取得
      this.dbOperationService
        .getNoTemplateDisplayData(endPoint, pkeyId)
        .subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            // // 前画面へ戻る
            // this.location.back();
          } else {
            // 検索結果を格納
            this.searchResultLogList = response.body
          }
        });
    } else {
      // 検索結果を取得
      this.dbOperationService
        .getNoTemplateDisplayData(endPoint, pkeyId)
        .subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            // // 前画面へ戻る
            // this.location.back();
          } else {
            // 検索結果を格納
            this.searchResultLogList = response.body[0];
          }
        });

    }
  }

  /**
   * 更新後検索結果取得
   */
  public getSearchResultList(endPoint: string, pkeyId: string, screen_id: string): void {
    if(screen_id == "b211" || screen_id == "b212" || screen_id == "e202" || screen_id == "h301"){
      // 検索結果を取得
      this.dbOperationService
        .getNoTemplateDisplayData(endPoint, pkeyId, true)
        .subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            // // 前画面へ戻る
            // this.location.back();
          } else {
            // 検索結果を格納
            this.searchResultList = response.body;
          }
        });
    } else{
      // 検索結果を取得
      this.dbOperationService
        .getNoTemplateDisplayData(endPoint, pkeyId)
        .subscribe((response) => {
          if (this.commonService.checkNoneResponse(response)) {
            // // 前画面へ戻る
            // this.location.back();
          } else {
            // 検索結果を格納
            this.searchResultList = response.body[0];
          }
        });
    }
  }

  /**
   * 辞書値リストを取得
   * @param hideCode 非表示ラジオボタン
   */
  protected getApprovalSpecCodeList(dicId: number, hideCode: number[]) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_DIC_LISTS);

    // 辞書情報取得処理
    this.dbOperationService.getDicLists(dicId).subscribe((response) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_DIC_LISTS);

      // 辞書情報が存在するか否か
      if (this.commonService.checkNoneResponse(response)) {
        // 辞書情報に存在しない場合
        this.approvalSpecCodeList = new Array();

        return;
      }

      // 辞書情報に存在する場合

      // ラジオボタン隠しが存在するか
      if (!hideCode.length) {
        // 存在しない場合
        this.approvalSpecCodeList = response.body;

        return;
      }

      // 非表示ラジオボタンにないコードのみ抽出
      const dicDataList = response.body.filter(
        (dicData) => !hideCode.includes(Number(dicData.sp_code))
      );

      // 辞書情報を格納
      this.approvalSpecCodeList = dicDataList;
    });
  }

  /**
   * 値NULL判定
   */
  public checkNull(val: any, attr_first: string, attr_second?: string): any {
    if(val == null || typeof val === 'undefined' || !Object.keys(val).length){
      return null;
    }
    return attr_second == null ? val[attr_first] : val[attr_first][attr_second];
  }

  /**
   * JSON型→string型変換
   */
  public convertJSONtoString(val: any): any {
    if(val == null || typeof val === 'undefined' || !Object.keys(val).length){
      return null;
    }
    return JSON.stringify(val);
  }
}
